<app-header-title>
  <span title>تعديل الحضور والانصراف</span>
</app-header-title>

<div style="padding: 1rem 2rem;">

  <dx-tab-panel 
    [(selectedIndex)]="selectedTabIndex"
    [animationEnabled]="true" 
    [rtlEnabled]="currentLang == 'ar'">

    <!-- ===== Tab 1: عرض وتعديل من الـ Grid ===== -->
    <dxi-item title="عرض وتعديل وحذف البيانات" icon="find">
      <div style="padding: 1rem;">

        <app-general-calc-salary-inputs
          #salaryInputs
          [currentLang]="currentLang"
          (formDataChanged)="onFormDataChanged($event)">
        </app-general-calc-salary-inputs>

        <div style="display: flex; gap: 10px; padding: 1rem 0; flex-wrap: wrap;">
          <dx-button 
            text="بحث" icon="search"
            type="default" [width]="150"
            (onClick)="applyFilter()">
          </dx-button>

          <!-- <dx-button 
            text="إعادة تعيين" icon="refresh"
            type="normal" stylingMode="outlined" [width]="150"
            (onClick)="resetFilter()">
          </dx-button> -->

          <!-- زر الحفظ - يظهر فقط لو فيه تعديلات -->
          <dx-button 
            
        [text]="'حفظ التعديلات (' + modifiedCount + ')'"
            icon="save"
            type="success"
            [width]="200"
            [disabled]="isSavingGrid"
            (onClick)="saveGridChanges()">
          </dx-button>
<dx-button
  text="حذف المحدد"
  icon="trash"
  type="danger"
  [disabled]="selectedIds.length === 0 || isDeleting"
  (onClick)="deleteSelected()">
</dx-button>
          <dx-load-indicator *ngIf="isSavingGrid" [visible]="true" [height]="30" [width]="30">
          </dx-load-indicator>
        </div>

    <dx-data-grid
  #dataGridVar
  [dataSource]="gridDataSource"
  keyExpr="_key"
  [showBorders]="true"
  [columnAutoWidth]="true"
  width="100%"
  [rtlEnabled]="currentLang == 'ar'"
  (onSelectionChanged)="onSelectionChanged($event)"
  (onRowUpdating)="updateRow($event)"
  (onRowUpdated)="onRowUpdated($event)">

  <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
  <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="false" [allowAdding]="false"></dxo-editing>

  <dxi-column dataField="employeeCode" caption="كود الموظف" [allowEditing]="false" [width]="100"></dxi-column>
  <dxi-column dataField="employeeName" caption="اسم الموظف" [allowEditing]="false" [width]="180"></dxi-column>
  <dxi-column dataField="dateOfDay"    caption="التاريخ"     [allowEditing]="false" [width]="120"></dxi-column>

  <dxi-column 
    dataField="time" 
    caption="الوقت" 
    [allowEditing]="true" 
    [width]="200"
    cellTemplate="timeCellTemplate"
    editCellTemplate="timeEditTemplate">
  </dxi-column>

  <dxi-column dataField="durationName" caption="فترة العمل" [allowEditing]="false" [width]="150"></dxi-column>

  <!-- ✅ Template جوه الـ grid -->
  <div *dxTemplate="let cell of 'timeCellTemplate'">
    <span style="display:flex; align-items:center; gap:8px; justify-content:flex-end;">
      <span>{{ cell.value || '---' }}</span>
      <span 
        [style.background]="cell.data.attending_LeavingType === 1 ? '#d4edda' : '#fff3cd'"
        [style.color]="cell.data.attending_LeavingType === 1 ? '#155724' : '#856404'"
        style="padding:2px 10px; border-radius:12px; font-size:12px; font-weight:600;">
        {{ cell.data.attending_LeavingType === 1 ? '● حضور' : '● انصراف' }}
      </span>
    </span>
  </div>

  <!-- ✅ Edit Template جوه الـ grid -->
  <div *dxTemplate="let cell of 'timeEditTemplate'">
    <span style="display:flex; align-items:center; gap:8px;">
      <span 
        [style.background]="cell.data.attending_LeavingType === 1 ? '#d4edda' : '#fff3cd'"
        [style.color]="cell.data.attending_LeavingType === 1 ? '#155724' : '#856404'"
        style="padding:2px 10px; border-radius:12px; font-size:12px; font-weight:600; white-space:nowrap;">
        {{ cell.data.attending_LeavingType === 1 ? '● حضور' : '● انصراف' }}
      </span>
      <dx-text-box 
        [value]="cell.value"
        (onValueChanged)="cell.setValue($event.value)"
        placeholder="HH:mm"
        [width]="100">
      </dx-text-box>
    </span>
  </div>

</dx-data-grid>

      </div>
    </dxi-item>

    <!-- ===== Tab 2: استيراد من Excel ===== -->
    <dxi-item title="استيراد من Excel" icon="xlsxfile">
      <div style="padding: 1rem;">

        <!-- أزرار الرفع والقالب -->
        <div style="display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 20px; align-items: center;">

          <input type="file" (change)="onFileUploaded($event)"
                 accept=".xlsx, .xls" #excelInput style="display:none" />

          <dx-button 
            text="اختر ملف Excel" icon="xlsxfile" 
            type="success" stylingMode="contained"
            [disabled]="isUploadingBulk"
            (onClick)="excelInput.click()">
          </dx-button>

          <dx-button 
            text="تحميل القالب" icon="download"
            type="normal" stylingMode="outlined"
            (onClick)="downloadTemplate()">
          </dx-button>

          <dx-button 
            *ngIf="hasExcelData"
            text="مسح البيانات" icon="trash"
            type="danger" stylingMode="outlined"
            (onClick)="clearExcelData()">
          </dx-button>

          <div *ngIf="isUploadingBulk"
               style="display: flex; align-items: center; gap: 8px; 
                      padding: 8px 15px; background: #d4edda; border-radius: 6px;">
            <dx-load-indicator [visible]="true" [height]="20" [width]="20"></dx-load-indicator>
            <span style="font-size: 14px; color: #155724; font-weight: 500;">جاري المعالجة...</span>
          </div>
        </div>

        <!-- Grid المراجعة قبل الإرسال -->
        <div *ngIf="hasExcelData && !bulkResults">

          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
            <span style="font-weight: 600; color: #333;">
              <i class="dx-icon-info"></i>
              راجع البيانات وعدّل عليها قبل الإرسال ({{ excelDataSource.length }} سجل)
            </span>

            <dx-button
              text="إرسال"
              icon="upload"
              type="default"
              [disabled]="isUploadingBulk"
              (onClick)="submitExcelData()">
            </dx-button>
          </div>

          <dx-data-grid
            #excelGridVar
            [dataSource]="excelDataSource"
            keyExpr="tempId"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [rtlEnabled]="currentLang == 'ar'"
            [showRowLines]="true"
            [rowAlternationEnabled]="true">

            <dxo-editing 
              mode="cell" 
              [allowUpdating]="true" 
              [allowDeleting]="true" 
              [allowAdding]="false">
            </dxo-editing>

            <dxi-column dataField="employeeCode" caption="كود الموظف" [width]="120"></dxi-column>
            <dxi-column dataField="employeeName" caption="اسم الموظف" [width]="180"></dxi-column>
            <dxi-column dataField="dateOfDay" caption="التاريخ" dataType="date" format="dd/MM/yyyy" [width]="130"></dxi-column>
            <dxi-column dataField="timeAttending" caption="وقت الحضور" [width]="140"></dxi-column>
            <dxi-column dataField="timeLeave" caption="وقت الانصراف" [width]="140"></dxi-column>

          </dx-data-grid>
        </div>

        <!-- نتائج بعد الإرسال -->
        <!-- <div *ngIf="bulkResults" style="margin-top: 20px;">
          <dx-tab-panel 
            [selectedIndex]="bulkResults.failedCount > 0 ? 1 : 0"
            [animationEnabled]="true" 
            [rtlEnabled]="true">

            <dxi-item title="الناجحة ({{bulkResults.successCount}})" icon="check">
              <div style="padding: 15px;">
                <div *ngIf="bulkResults.successCount === 0"
                     style="text-align: center; padding: 40px; color: #999;">
                  <p>لا توجد سجلات ناجحة</p>
                </div>
                <dx-data-grid *ngIf="bulkResults.successCount > 0"
                              [dataSource]="bulkResults.successItems"
                              [width]="100"
                              [showBorders]="true" [height]="350"
                              [columnAutoWidth]="true" [rtlEnabled]="true">
                  <dxi-column dataField="employeeName" caption="اسم الموظف"></dxi-column>
                  <dxi-column dataField="dateOfDay" caption="التاريخ" dataType="date" format="dd/MM/yyyy"></dxi-column>
                  <dxi-column dataField="timeAttending" caption="وقت الحضور"></dxi-column>
                  <dxi-column dataField="timeLeave" caption="وقت الانصراف"></dxi-column>
                  <dxi-column dataField="workDurationSystemName" caption="نظام العمل"></dxi-column>
                </dx-data-grid>
              </div>
            </dxi-item>

            <dxi-item title="الأخطاء ({{bulkResults.failedCount}})" icon="close">
              <div style="padding: 15px;">
                <div *ngIf="bulkResults.failedCount === 0"
                     style="text-align: center; padding: 40px; color: #28a745;">
                  <p style="font-size: 16px; font-weight: 500;">رائع! جميع السجلات تم إضافتها بنجاح</p>
                </div>
                <div *ngIf="bulkResults.failedCount > 0">
                  <dx-button text="تصدير الأخطاء" icon="exportxlsx"
                             type="danger" stylingMode="outlined"
                             (onClick)="exportFailedRows()" style="margin-bottom: 15px;">
                  </dx-button>
                  <dx-data-grid [dataSource]="bulkResults.errors"
                                [showBorders]="true" [height]="350"
                                [columnAutoWidth]="true" [rtlEnabled]="true">
                    <dxi-column dataField="rowIndex" caption="السطر" [width]="70"></dxi-column>
                    <dxi-column dataField="employeeName" caption="اسم الموظف"></dxi-column>
                    <dxi-column dataField="dateOfDay" caption="التاريخ" dataType="date" format="dd/MM/yyyy"></dxi-column>
                    <dxi-column dataField="errors" caption="الأخطاء"></dxi-column>
                  </dx-data-grid>
                </div>
              </div>
            </dxi-item>

          </dx-tab-panel>
        </div> -->

      </div>
    </dxi-item>

  </dx-tab-panel>

<dx-popup
  [(visible)]="showResultPopup"
  [showTitle]="true"
  title="نتيجة العملية"
  [width]="700"
  [height]="400"
  [rtlEnabled]="currentLang == 'ar'"
  [showCloseButton]="true">

  <div *dxTemplate="let data of 'content'" style="padding: 15px;">

    <div style="display: flex; gap: 15px; margin-bottom: 20px;">

      <!-- حذف أو تحديث -->
      <div style="background: #d4edda; padding: 12px 20px; border-radius: 8px; text-align: center;">
        <div style="font-size: 24px; font-weight: bold; color: #155724;">
          {{ saveResult?.deletedCount ?? saveResult?.updatedCount ?? 0 }}
        </div>
        <div style="color: #155724;">
          {{ saveResult?.deletedCount != null ? 'تم حذفها' : 'تم تحديثها' }}
        </div>
      </div>

      <div style="background: #fff3cd; padding: 12px 20px; border-radius: 8px; text-align: center;">
        <div style="font-size: 24px; font-weight: bold; color: #856404;">
          {{ saveResult?.skipped?.length || 0 }}
        </div>
        <div style="color: #856404;">تم تخطيها</div>
      </div>

    </div>

    <!-- skipped list -->
    <div *ngIf="saveResult?.skipped?.length > 0">
      <p style="font-weight: 600; margin-bottom: 8px; color: #856404;">
        الموظفون الذين تم تخطيهم (لوجود راتب محسوب):
      </p>
      <dx-data-grid
        [dataSource]="saveResult.skipped"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [rtlEnabled]="currentLang == 'ar'"
        [height]="200">
        <dxi-column dataField="employeeName" caption="اسم الموظف"></dxi-column>
        <dxi-column dataField="reason"       caption="السبب"></dxi-column>
      </dx-data-grid>
    </div>

    <div *ngIf="!saveResult?.skipped?.length"
         style="text-align: center; padding: 20px; color: #155724;">
      <i class="dx-icon-check" style="font-size: 40px;"></i>
      <p>تمت العملية بنجاح على جميع السجلات</p>
    </div>

  </div>
</dx-popup>
</div>